import { render, staticRenderFns } from "./branchverifydiff.vue?vue&type=template&id=0833b176&scoped=true"
import script from "./branchverifydiff.vue?vue&type=script&lang=js"
export * from "./branchverifydiff.vue?vue&type=script&lang=js"
import style0 from "./branchverifydiff.vue?vue&type=style&index=0&id=0833b176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833b176",
  null
  
)

export default component.exports